export default defineAppConfig({
    icon: {
        class: 'inline-block align-middle', // default <Icon> class applied
        mode: 'svg', // default <Icon> mode applied
    }
})
